import React from 'react';
import { MindMapContext } from '../../../Context/contex';
import TemplateActiveToggle from '../../TemplateActiveToggle/TemplateActiveToggle';
import TemplateThumbnail from '../../TemplateThumbnail/TemplateThumbnail';
import DocumentMembers from '../../Members/members';
import { ShareModal } from '../../ShareModal/ShareModal';
import AppLauncherModal from '../../AppLauncher';
import Modes from '../../UserDetail/modes';
import UserColor from '../../UserColor/userColor';
import HeaderAvatar from '../../Avatar/HeaderAvatar';
import HeaderDivider from '../HeaderDivider';
import RightHeaderMenu from '../RightHeaderMenu';
import { getOtherMembers, isDocumentOwner } from '../documentAccess';
import styles from './RightHeader.module.css';

/**
 * Right half of the bar. The desktop group (members, share, apps, theme) hides
 * below 768px and the menu takes its place; it stays mounted because Modes is
 * what applies the theme. Template controls, the user's colour and the avatar
 * show at every width.
 */
const RightHeader = () => {
    const { documentInfo, userInfo, isTemplateDocument } = MindMapContext();
    const hasMembers = !isTemplateDocument && getOtherMembers(documentInfo, userInfo).length > 0;
    const canShare = !isTemplateDocument && isDocumentOwner(documentInfo, userInfo);

    return (
        <div className={styles.actions}>
            {isTemplateDocument && <TemplateActiveToggle />}
            {isTemplateDocument && <TemplateThumbnail />}
            <div className={styles.desktopGroup}>
                {hasMembers && (
                    <span className={styles.members}>
                        <DocumentMembers />
                    </span>
                )}
                {canShare && <ShareModal />}
                {(hasMembers || canShare) && <HeaderDivider size="short" />}
                <AppLauncherModal />
                <Modes />
            </div>
            <UserColor />
            <RightHeaderMenu />
            <HeaderAvatar />
        </div>
    );
};

export default RightHeader;
